import { State } from 'src/types'

export const indexFingerRight = (
  ctx: CanvasRenderingContext2D,
  state: State,
  needCatchFaceWrap: boolean // 捕球面折り返しが必要かどうか
): void => {
  const fingerColor = needCatchFaceWrap ? state.indexWeb?.color : state?.thumbWebAndIndexWeb?.color
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = fingerColor
  if (!needCatchFaceWrap) {
    // 捕球面折り返しが不要のケース
    ctx.beginPath()
    ctx.moveTo(515, 20) // 左上
    ctx.quadraticCurveTo(427, 170, 403, 356) // 左下
    ctx.quadraticCurveTo(448, 357, 480, 385) //
    ctx.quadraticCurveTo(499, 403, 495, 434) // 手口ベルト右上
    ctx.quadraticCurveTo(487, 457, 448, 467) //
    ctx.quadraticCurveTo(287, 483, 287, 485) // 手口ベルト左上
    ctx.quadraticCurveTo(336, 586, 336, 588) // 手口ベルト左下
    ctx.quadraticCurveTo(438, 600, 529, 585) // 手口ベルト右下
    ctx.quadraticCurveTo(562, 555, 562, 555) // 親指ハミダシ下
    ctx.quadraticCurveTo(602, 456, 647, 390) // 親指ハミダシ中間
    ctx.quadraticCurveTo(679, 340, 737, 279)
    ctx.quadraticCurveTo(732, 263, 715, 260) // 親指頂点
    ctx.quadraticCurveTo(667, 280, 573, 361) // ウェブ右下
    ctx.quadraticCurveTo(512, 331, 482, 257) // ウェブ左下
    ctx.quadraticCurveTo(485, 209, 559, 68)
    ctx.quadraticCurveTo(563, 48, 553, 32)
    ctx.quadraticCurveTo(537, 21, 515, 20)
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  } else {
    // 捕球面折り返しが必要なケース
    ctx.beginPath()
    ctx.moveTo(515, 20) // 左上
    ctx.quadraticCurveTo(427, 170, 403, 356) // 左下
    ctx.quadraticCurveTo(457, 369, 457, 369) // 右下
    ctx.quadraticCurveTo(485, 209, 559, 68)
    ctx.quadraticCurveTo(563, 48, 553, 32)
    ctx.quadraticCurveTo(537, 21, 515, 20)
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }
}

export const indexFingerLeft = (ctx: CanvasRenderingContext2D, color: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  ctx.beginPath()
  ctx.moveTo(513, 20) // 右上
  ctx.quadraticCurveTo(486, 22, 470, 41)
  ctx.quadraticCurveTo(380, 177, 377, 360) // 左下
  ctx.quadraticCurveTo(400, 357, 402, 356) // 右下
  ctx.quadraticCurveTo(424, 170, 513, 20) // 右下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
